import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useMemberAuth } from "@/member/MemberAuthContext";
import { BfgShell } from "./gameShared";

const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "") + "/api";

export default function FacilitatedPreparationPage() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const stage = params.get("stage");
  const navigate = useNavigate();
  const { refresh } = useMemberAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    document.title = "Your Board Fundraising Preparation | Nonprofit Board Builder";
    let live = true;
    axios.get(`${API}/board-fundraising/preparation/${encodeURIComponent(token)}`).then(async response => {
      if (!live) return;
      setData(response.data);
      sessionStorage.setItem("fundraisingPreparationToken", token);
      sessionStorage.setItem("fundraisingPreparationPath", "/board-fundraising/preparation/" + encodeURIComponent(token));
      if (stage === "organization" || (stage === "individual" && !response.data.individual_completed)) {
        await refresh();
        if (!live) return;
        navigate(stage === "individual" && response.data.individual_token ? `/play/${response.data.individual_token}` : `/game/setup?stage=${stage}`, { replace: true });
      }
    }).catch(err => { if (live) setError(err.response?.data?.detail || "The preparation link could not be opened. Ask Rooney to resend it."); });
    return () => { live = false; };
  }, [token, stage, refresh, navigate]);
  const open = async type => {
    setBusy(true);
    await refresh();
    navigate(type === "individual" && data.individual_token ? `/play/${data.individual_token}` : `/game/setup?stage=${type}`);
  };
  return <BfgShell><main className="bfg-flow" style={{ maxWidth: 760, margin: "0 auto", padding: "50px 20px" }}>
    <h1>Your Board Fundraising Preparation</h1>
    {error ? <p role="alert">{error}</p> : !data ? <p>Opening your private preparation forms…</p> : <>
      <p>Hi {data.name}. Complete these two parts before working with Rooney. Your answers are saved to your organisation’s existing workspace.</p>
      <div className="bfg-stage-stack"><div className="bfg-clean-stage"><h2>Organisation Information</h2><p>{data.organization_completed ? "Your organisation information is saved." : "Tell us about your organisation, fundraising goal and current fundraising."}</p><button className="bfg-btn bfg-btn-primary" disabled={busy} onClick={() => open("organization")}>{data.organization_completed ? "REVIEW ORGANISATION INFORMATION" : "COMPLETE ORGANISATION INFORMATION"}</button></div>
        <div className="bfg-clean-stage"><h2>Your Individual Fundraising Game</h2><p>{data.individual_completed ? "Your individual game is saved. Rooney can review your answers in your workspace." : "Share your five ideas and how you can participate."}</p>{!data.individual_completed && <button className="bfg-btn bfg-btn-primary" disabled={busy} onClick={() => open("individual")}>OPEN YOUR INDIVIDUAL GAME</button>}</div></div>
      {data.organization_completed && data.individual_completed && <p>Thank you. Your preparation is complete and Rooney can work with your answers in your dashboard.</p>}
    </>}
  </main></BfgShell>;
}
